// Path: libs/core/shell/src/lib/layout/admin/services/admin-license.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AdminLicenseService {
  private readonly enabledLicenses: Record<string, boolean> = {
    dashboard: true,
    products: true,
    categories: true,
    scheduling: true,
    images: true,
    orders: true,
    showcase: true,
    extras: true,
    delivery: true,
    financial: true,
    settings: true,
    company: true,
  };

  hasModuleLicense(licenseKey?: string): boolean {
    if (!licenseKey) {
      return true;
    }

    return !!this.enabledLicenses[licenseKey];
  }
}
